module.exports = __webpack_public_path__ + "img/banner_appstore.9ebdc2c9.png";